export default function Percentile() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Percentile</h1>
      <p>Content for Percentile goes here.</p>
    </div>
  );
}